export enum MegaMenuRecipeVariants {
	V1 = 'v1',
	V2 = 'v2',
	V3 = 'v3',
	V4 = 'v4',
}
